// extracted by mini-css-extract-plugin
export default {"routeBtn":"ServiceDetailAddress_routeBtn__mOZD1","disableGeoBitn":"ServiceDetailAddress_disableGeoBitn__-ecQt","btnLoader":"ServiceDetailAddress_btnLoader__F3pI-"};